import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  Renderer2,
  Input,
} from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "../../../providers/auth.service";

// import { AppThemeService } from "src/app/providers/app.theme.service";
import { UserService } from "src/app/providers/user.service";
// import { THEMES } from "./themes";
import { FormGroup, FormControl, UntypedFormBuilder, Validators } from "@angular/forms";
import { replace } from "lodash";
import { PasskeyComponent } from "src/app/shared/components/passkey/passkey.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PasskeyService } from "src/app/providers/passkey.service";
import { CommonService } from "src/app/providers/common.service";
import { NotificationHubService } from "src/app/providers/notification-hub/notification-hub.service";
import { ImportantNotificationsModalComponent } from "src/app/shared/components/notification-hub/important-notifications-modal.component";
import { BroadcastConsoleComponent } from "src/app/shared/components/broadcast-console/broadcast-console.component";
import { SocketService } from "src/app/providers/socket/socket.service";
import { UserType } from "src/app/core/model/user-type.enum";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
})
export class NavbarComponent implements OnInit {
  
  currentUser = {
    firstName: "",
    email: "",
    lastName: "",
    userType:""
  };

  iscyanchecked : boolean = true;
  isbluechecked : boolean = false;
  ispurplechecked : boolean = true;
  passkeyEnable : boolean =  false;

  languages = [
    { code: "en", name: "English", icon: "us" },
    { code: "es", name: "Spanish", icon: "es" },
    // { code: "fr", name: "French", icon: "fr" },
    // { code: "in", name: "Tamil", icon: "in" },
  ];
  selectedLanguage = this.languages[0];
  defaultTheme: any;
  // public is_eomm_user = localStorage.getItem('ecomm_users')?.includes(JSON.parse(localStorage.getItem('current_user'))?.email) 
  public is_eomm_user = false;
  public unread_notifications = 0;
  private importantModalRef: any = null;
  
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    private translate: TranslateService,
    private authService: AuthService,
    // private appThemeService: AppThemeService,
    private userService: UserService,
    private formBuilder: UntypedFormBuilder,
    private ngbModal: NgbModal,
    private readonly passkeyService: PasskeyService,
    private commonService: CommonService,
    private notificationHub: NotificationHubService,
    private socketService: SocketService,
  ) {
    this.is_eomm_user = JSON.parse(localStorage.getItem('ecomm_allowed_user_type') || '[]').indexOf(this.authService.getUser?.userType) > -1;
    translate.setDefaultLang(this.selectedLanguage.code);
  }

  ngOnInit(): void {
    // this.onSidebarThemeChange(this.defaultTheme);
    this.getCurrentUser();
    this.getPasskeyShow();

    this.socketService.connectIfNeeded();
    this.notificationHub.load();

    this.notificationHub.unreadCount$.subscribe((count) => {
      this.unread_notifications = count;
    });

    this.notificationHub.importantModalRequested$.subscribe((items) => {
      if (!items.length) return;
      if (this.importantModalRef) {
        this.importantModalRef.componentInstance.items = items;
        return;
      }
      this.importantModalRef = this.ngbModal.open(ImportantNotificationsModalComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true
      });
      this.importantModalRef.componentInstance.items = items;
      this.importantModalRef.result.finally(() => {
        this.importantModalRef = null;
      });
    });

    this.defaultTheme = this.authService.getUser.themeColor;
  
    if(this.defaultTheme == "theme-purple-light"){
      this.ispurplechecked = true;
      this.iscyanchecked = false;
      this.isbluechecked = false;
    }
    if(this.defaultTheme == "theme-cyan-light") {
      this.iscyanchecked = true;
      this.isbluechecked = false;
      this.ispurplechecked = false;
    }
    if (this.defaultTheme == 'theme-bluegrey-light') {     
      this.isbluechecked = true;
      this.iscyanchecked = false;
      this.ispurplechecked = false;
    }
    //this.onSidebarThemeChange(this.defaultTheme);
    // console.log("this.defaultTheme",this.defaultTheme);
  }
  ngOnDestroy(): void {
    this.ngbModal.dismissAll();
  }

  async getPasskeyShow() {
    const serverCredential = await this.passkeyService.checkServerForCredentials();

    if (serverCredential.exclueUserType) {
      // Make sure exclueUserType is treated as an array of strings to avoid 'never' typing issues
      const excluded = Array.isArray(serverCredential.exclueUserType)
        ? serverCredential.exclueUserType.map(String)
        : [];

      this.passkeyEnable =
        serverCredential.canShowPasskey &&
        !excluded.includes(this.currentUser.userType);
    } else {
      this.passkeyEnable = !!serverCredential.canShowPasskey;
    }
  }

  /**
   * Sidebar toggle on hamburger button click
   */
  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle("sidebar-open");
  }

  /**
   * Logout
   */
  async onLogout() {
    this.ngbModal.dismissAll();
    const logOut = await this.authService.logoutService()
    logOut.subscribe(res => {
       console.log("logout")
    })    // this.authService.testAxiosLogutService();
  }

  setUpBiometricLogin(){
      let modalRef = this.ngbModal.open(PasskeyComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.isLoading = true
      modalRef.componentInstance.header = `LOGIN-AS CONFIRMATION`;
  }

  agentOfficeRoleChange(item){
    return replace(this.authService.subIsoToAgentOffice(item), /_/g,' ');
  }
  

  useLanguage(index: number) {
    this.selectedLanguage = this.languages[index];
    this.translate.use(this.selectedLanguage.code);
  }
  /**
   * custom Switching sidebar light/dark
   */
  onSidebarThemeChange(data) {
    this.document.body.classList.remove(
      "sidebar-light",
      "theme-cyan-light",
      "theme-bluegrey-light",
      "theme-purple-light"
    );
    this.document.body.classList.add(data);
    this.getTheme(data);
    this.document.body.classList.remove("settings-open");

    this.iscyanchecked = false;
    this.isbluechecked = false;
    this.ispurplechecked = false;

    // Set the checked value for the selected theme to true
     const themeMap = { 
      'theme-cyan-light': 'iscyanchecked', 
      'theme-bluegrey-light': 'isbluechecked', 
      'theme-purple-light': 'ispurplechecked' 
    }; 
    if (themeMap.hasOwnProperty(data)) { 
      this[themeMap[data]] = true; 
    }
    this.userService.userFavTheme.next('purple');

  }

  getCurrentUser() {
    this.currentUser = this.authService.getUser;
  }

  getTheme(themeClass){
    let params = {
      themeColor: themeClass
    }
    this.userService.getTheme(this.userService.getThemeColorById, params).subscribe(data => {
      this.authService.updateUser(params);
        console.log(data);
    });
  }

  getInitials() {
    let initials = this.currentUser.firstName[0]
    initials += this.currentUser.lastName ? this.currentUser.lastName[0] : ''
    return initials
  }
  // toogle() {
  //   this.iscyanchecked = !this.iscyanchecked;
  //   this.isbluechecked = !this.isbluechecked;
  // }
  getRelativeTime(date: Date): string {
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - new Date(date).getTime()) / 1000);

    if (diffInSeconds < 60) {
      return `${diffInSeconds} sec ago`;
    } 
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    if (diffInMinutes < 60) {
      return `${diffInMinutes} min ago`;
    }
    const diffInHours = Math.floor(diffInMinutes / 60);
    if (diffInHours < 24) {
      return `${diffInHours} h ago`;
    }
    const diffInDays = Math.floor(diffInHours / 24);
    if (diffInDays < 30) {
      return `${diffInDays} day${diffInDays > 1 ? 's' : ''} ago`;
    }
    const diffInMonths = Math.floor(diffInDays / 30);
    if (diffInMonths < 12) {
      return `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`;
    }
    const diffInYears = Math.floor(diffInMonths / 12);
    return `${diffInYears} year${diffInYears > 1 ? 's' : ''} ago`;
  }

  view = (msgData:any) => {

  }

  // download = async (isDownload: boolean, msgData: any) => {
  //   try {
  //     console.log("LOG_", msgData.location)
  //     if (!msgData?.location) return;
  //     // const data = await this.commonService.getCommonFileDownload(msgData.location).toPromise();
  //     // console.log("data", data)
  //     let downloadURL = window.URL.createObjectURL(msgData.location);
  //     console.log("LOG", downloadURL)
  //     const fileName = msgData?.fileName;
  //     isDownload ? await fs.saveAs(downloadURL, fileName) : window.open(downloadURL, "_blank");
  //   } catch (error) {
  //     console.log("LOG_", error)

  //   }

  // }
  download = async (isDownload: boolean, msgData: any) => {
    try {
      if (!msgData?.location) return;
      const fileName = msgData?.fileName || 'download';

      if (!isDownload) {
        window.open(msgData.location, '_blank');
        return;
      }

      const a = window.document.createElement('a');
      a.href = msgData.location;
      a.download = fileName;
      a.target = "_blank"; // <--- IMPORTANT
      window.document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error('LOG_', error);
    }
  }

  openBroadcastConsole = () => {
    const modalRef = this.ngbModal.open(BroadcastConsoleComponent, {
      size: 'xl',
      backdrop: 'static',
      centered: true,
      windowClass: 'broadcast-console-modal'
    });
    modalRef.componentInstance.variant = 'modal';
  }

}

